import { render, staticRenderFns } from "./section-name.vue?vue&type=template&id=7d6366bc&scoped=true&"
import script from "./section-name.vue?vue&type=script&lang=js&"
export * from "./section-name.vue?vue&type=script&lang=js&"
import style0 from "./section-name.vue?vue&type=style&index=0&id=7d6366bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6366bc",
  null
  
)

export default component.exports